import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = () => {

	$(document)
		// secondary
		.on('click', '.m-secondary__item--submenu .m-secondary__link', function (e) {
			e.preventDefault();

			var $this = $(this),
				$other = $('.m-secondary__item--submenu'),
				$closest = $this.closest('.m-secondary__item--submenu'),
				$popup = $closest.find('.m-popup');

			// fixed width
			$popup.removeAttr('style');
			if ($popup.offset().left < 0) {
				$popup.width(Math.floor($popup.width() + $popup.offset().left - 20));
			}

			// classes
			$other.not($closest).removeClass('is-open');
			$closest.toggleClass('is-open');
		})
		// basket
		.on('click', '.b-basket__link', function (e) {
			if (MQ('mdUp')) {
				e.preventDefault();

				var $this = $(this),
					$closest = $this.closest('.b-basket');

				$closest.toggleClass('is-open');
			}
		})
		// out click
		.on('click', function (e) {

			if (!$(e.target).closest('.m-secondary__item--submenu').length) {
				$('.m-secondary__item--submenu').removeClass('is-open');
			}
			if (!$(e.target).closest('.b-basket').length) {
				$('.b-basket').removeClass('is-open');
			}

		});

};
